var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100% - 0rem)","width":"100%"}},[_c('div',{staticStyle:{"height":"calc(100% - 0rem)","width":"100%"},attrs:{"id":"StudentStatistics"}}),(false)?_c('div',{staticStyle:{"height":"calc(100% - 0rem)","width":"100%"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }